module.exports = __webpack_public_path__ + "static/media/trades.9c5077ee.svg";